import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LocalizedDatePipe } from '@myshared/localized-date.pipe';

@Component({
    selector: 'app-availability-downgrade-confirm',
    templateUrl: './availability-downgrade-confirm.component.html',
    providers: [LocalizedDatePipe],
    standalone: false
})
export class AvailabilityDowngradeConfirmComponent {

    @Input() applianceId: string;
    @Input() applianceName: string;

    @Output() backEvent = new EventEmitter<void>();
    @Output() confirm = new EventEmitter<number>();

    public accept = false;

    onConfirm() {
        if (!this.accept) return;
        this.confirm.emit();
    }

    public onAccept(accept: boolean) {
        this.accept = accept;
    }

    public get displayName() {
        return `[${this.applianceId}] ${this.applianceName ?? ''}`;
    }
}
